import { createFileRoute, redirect } from "@tanstack/react-router";
import { fetchQuery, graphql } from "relay-runtime";
import { environment } from "@/relay/environment";
import type { routesInitialPageQuery } from "./__generated__/routesInitialPageQuery.graphql";

export const Route = createFileRoute("/")({
	component: App,
	loader: async ({ context }) => {
		const { club, session } = context;

		if (club.visibility === "PUBLIC" || club.isMember) {
			const data = await fetchQuery<routesInitialPageQuery>(
				environment,
				graphql`
				query routesInitialPageQuery($slug: String!) {
				  club(slug: $slug) {
						configuration(key: "INITIAL_PAGE")

						communityEnabled: configuration(key: "COMMUNITY_ENABLED")
						coursesEnabled: configuration(key: "COURSES_ENABLED")
						eventsEnabled: configuration(key: "EVENTS_ENABLED")
						rankingEnabled: configuration(key: "LEADERBOARD")

						events(orderBy: CHRONOLOGICAL) {
							edges {
								node {
									id
								}
							}
						}
						groups {
							spaces {
								isMember
								visibility
							}
						}
						coursePage {
							id
							categories(status: ACTIVE) {
								courses(status: ACTIVE) {
									visibility
									canView
								}
							}
						}
					}
				}
			`,
				{ slug: club.slug },
			).toPromise();

			const enabledPages = [
				[
					"courses",
					(!data?.club.coursesEnabled || data?.club.coursesEnabled === "1") &&
						data?.club?.coursePage.categories.some((c) =>
							c.courses.some(
								(c) =>
									c.visibility === "PRIVATE" ||
									c.visibility === "PUBLIC" ||
									c.visibility === "MEMBER_ONLY" ||
									c.canView,
							),
						),
				],
				[
					"community",
					(!data?.club.communityEnabled ||
						data?.club.communityEnabled === "1") &&
						data?.club?.groups
							.filter(Boolean)
							.some((g) =>
								g.spaces
									.filter(Boolean)
									.some((s) => s.isMember || s.visibility === "PUBLIC"),
							),
				],
				[
					"events",
					(!data?.club.eventsEnabled || data?.club.eventsEnabled === "1") &&
						(data?.club?.events?.edges.filter((e) => Boolean(e.node)).length ||
							0) > 0,
				],
				[
					"ranking",
					data?.club.rankingEnabled === "ENABLED" ||
						data?.club.rankingEnabled === "1",
				],
			].filter(([_, enabled]) => enabled);

			const defaultPage = enabledPages[0]?.[0];

			if (!defaultPage) {
				throw redirect({
					href: "https://www.scarf.club",
				});
			}

			switch (data?.club.configuration) {
				case "COMMUNITY":
					if (
						!data?.club.communityEnabled ||
						data?.club.communityEnabled === "1"
					) {
						throw redirect({
							to: "/comunidade",
						});
					}
					break;
				case "EVENTS":
					if (!data?.club.eventsEnabled || data?.club.eventsEnabled === "1") {
						throw redirect({
							to: "/eventos",
						});
					}
					break;
				case "RANKING":
					if (
						!data?.club.rankingEnabled ||
						data?.club.rankingEnabled === "1" ||
						data?.club.rankingEnabled === "ENABLED"
					) {
						throw redirect({
							to: "/ranking/leaderboard",
						});
					}
					break;
				case "COURSES":
					if (!data?.club.coursesEnabled || data?.club.coursesEnabled === "1") {
						throw redirect({
							to: "/cursos",
						});
					}
					break;
				default:
					break;
			}

			switch (defaultPage) {
				case "community":
					throw redirect({
						to: "/comunidade",
					});
				case "events":
					throw redirect({
						to: "/eventos",
					});
				case "ranking":
					throw redirect({
						to: "/ranking/leaderboard",
					});
				default:
					throw redirect({
						to: "/cursos",
					});
			}
		}

		if (session?.accessToken) {
			throw redirect({
				to: "/cursos",
			});
		} else {
			throw redirect({
				to: "/cadastro",
			});
		}
	},
});

function App() {
	return null;
}
